import React from 'react'
import { Box, Button, Dialog, DialogContent, TextField, Typography, useTheme } from '@mui/material';
import * as yup from "yup";
import { Formik } from "formik";
import { tokens } from '../theme';

function MarketProductDialog({ open, handleClose, handleSubmit, marketProduct }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.colors);

    var initialValues = {
        name: marketProduct?.name ? marketProduct.name : "",
        description: marketProduct?.description ? marketProduct.description : "",
        app_price: marketProduct?.app_price ? marketProduct.app_price : "",
        link: marketProduct?.link ? marketProduct.link : "",
        image: null,
        image_link: marketProduct?.image_link ? marketProduct.image_link : "",
        coupons: marketProduct ? "empty" : "",
    }

    var shapeObject = {
        name: yup.string().required("zorunlu"),
        description: yup.string().required("zorunlu"),
        app_price: yup.number().required("zorunlu"),
        link: yup.string().required("zorunlu"),
        image: yup.mixed().nullable().when('image_link', {
            is: (image_link) => !image_link || image_link === "",
            then: () => yup.mixed().required("zorunlu")
        }),
        image_link: yup.string(),
        coupons: yup.string().required("zorunlu"),
    }

    const schema = yup.object().shape(shapeObject);

    return (
        <Dialog
            sx={{ margin: "0 auto" }}
            open={open}
            fullWidth
            maxWidth="md"
            onClose={handleClose}
        >
            <Box m="20px" mb="0" textAlign="center">
                <Typography variant='h3'>
                    {marketProduct ? marketProduct.name : "Yeni Ürün Ekle"}
                </Typography>
            </Box>
            <DialogContent>
                <Box>
                    <Formik
                        onSubmit={handleSubmit}
                        initialValues={initialValues}
                        validationSchema={schema}
                    >
                        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
                            <form onSubmit={handleSubmit}>
                                <Box display="grid" gap="15px" gridTemplateColumns="repeat(3, minmax(0, 1fr))" mx="75px" my="25px">
                                    <Box textAlign="center" sx={{ gridColumn: "span 3" }}>
                                        <Typography variant="h6">Görsel (560 x 560)</Typography>
                                        <Button variant="contained" component="label" style={{ textAlign: "center", background: colors.grey[700], height: "150px", width: "150px" }}>
                                            {(values.image || (values.image_link && values.image_link !== "")) && <img alt='product' style={{ maxWidth: "140px", maxHeight: "140px", minWidth: "140px", minHeight: "140px", objectFit: "contain" }} src={values.image ? URL.createObjectURL(values.image) : values.image_link} />}
                                            <input id="image" name="image" type="file" accept=".png, .jpeg, .jpg" onChange={(event) => { setFieldValue("image", event.target.files[0]); }} hidden />
                                        </Button>
                                    </Box>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Ürün Başlığı"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.name}
                                        name="name"
                                        error={!!touched.name && !!errors.name}
                                        helperText={touched.name && errors.name}
                                        sx={{ gridColumn: "span 3", mt: "10px" }}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Ürün Açıklaması"
                                        multiline
                                        rows={6}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.description}
                                        name="description"
                                        error={!!touched.description && !!errors.description}
                                        helperText={touched.description && errors.description}
                                        sx={{ gridColumn: "span 3" }}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Ürün Linki"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.link}
                                        name="link"
                                        error={!!touched.link && !!errors.link}
                                        helperText={touched.link && errors.link}
                                        sx={{ gridColumn: "span 3", mt: "18px" }}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="number"
                                        label="App Fiyatı"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.app_price}
                                        name="app_price"
                                        error={!!touched.app_price && !!errors.app_price}
                                        helperText={touched.app_price && errors.app_price}
                                        sx={{ gridColumn: "span 1", mt: "18px" }}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Kodlar (virgül ile ayırınız)"
                                        multiline
                                        rows={6}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.coupons}
                                        name="coupons"
                                        error={!!touched.coupons && !!errors.coupons}
                                        helperText={touched.coupons && errors.coupons}
                                        sx={{ gridColumn: "span 3" }}
                                    />
                                </Box>
                                <Box display="flex" justifyContent="center" m="20px 20px 0px 20px">
                                    <Button type="submit" color="secondary" variant="contained">
                                        <Typography variant='h5'>Kaydet</Typography>
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default MarketProductDialog